<template>
    <va-edit-layout>
        <DebtRecoveryEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></DebtRecoveryEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
